import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-126207b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "sidebar__block"
}
const _hoisted_2 = {
  key: 0,
  class: "sidebar__project-info"
}
const _hoisted_3 = { class: "sidebar__project-icon-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar__project-line" }, null, -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "menu__items"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar__line" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

import { computed, inject, nextTick, onMounted, onUnmounted, provide, ref, watch } from 'vue';
import { onBeforeRouteUpdate, RouteLocation, RouterLink, useRoute, useRouter } from 'vue-router';
import { ArrowRightIcon, PlusIcon, UserGroupIcon } from 'tir-style-system/icons/outline';
import { SidebarMenuItem, SidebarSkeleton } from './components';
import {
  NamespaceModel,
  QueueTasksModel,
  GroupModel,
  UpdateQueueNameModel,
  DeleteQueueInfoModel,
  GroupCreateEventResponseModel,
  DeleteGroupEventResponseModel,
  GroupUpdateNameEventResponseModel,
} from './models';
import { AdapterService } from './adapter';
import { useSidebarTree } from './composables';
import { TreeItemType } from './enums';
import { projectInjectKey } from '@/inject-keys';
import { CreateNamespaceDrawer, CreateNamespaceResultModel } from '@/components';
import { DragModel } from '../tir-pm-kanban';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmIconView,
  TirPmScrollbar,
} from 'tir-components';
import RemoveStopperModal from './components/remove-stopper-modal.vue';
import { CurrentUser } from 'tir-pm-user-core';
import { ProjectModel } from '@/models';
import TirPmSkeleton from '../tasks-kanban/components/TirPmSkeleton/tir-pm-skeleton.vue';
import { CreateNamespaceInfo, DeleteNamespaceInfo, UpdateNamespaceInfo } from './types';
import { MonitoringMenu } from './components/monitoring';

const defaultSidebarWidth = 72;
const defaultOpenSidebarWidth = 375;

export default /*#__PURE__*/_defineComponent({
  __name: 'sidebar-menu',
  props: {
  /**ID очереди тикета */
  /**Статичное отображение сайдбара */
  isStatic: { type: Boolean, default: false },
  /**Ширина сайдбара */
  width: { type: Number },
  /**id проекта */
  projectProps: { type: ProjectModel, default: new ProjectModel() },
  /**Скрыть информацию о проекте */
  hideProjectInfo: { type: Boolean },
  /**Отображать только рабочие области */
  onlyNamespaces: { type: Boolean },
  /**Пропуск инициализации */
  skipInit: { type: Boolean, default: false },
},
  emits: ["openNamespace", "openGroup", "openQueue", "getQueueItems"],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();

const adapter = new AdapterService();

/**Параметры */

/**События */


/**Кол-во сотрудников в моей команде */
const myTeamCountEmployees = ref(0);

/**Есть элемент над которым выполняется какое либо действие */
const haveActionItem = ref(false);
const isLoading = ref(false);

watch(
  () => props.projectProps,
  async () => {
    isLoading.value = true;
    if (props.projectProps) {
      const resp = await adapter.getTree(Number(props.projectProps.Id), props.onlyNamespaces);
      isLoading.value = false;
      if (resp.IsSuccess) setSidebarItems(resp.Value);
      // emit("sidebarItems", sidebarItems);
    }
  },
);

/** Открыто ли меню */
const isSidebarOpen = ref(true);
/** Показывать только иконки */
const showOnlyIcons = ref(false);
/**Текущий перетаскиваемый элемент */
const currentDragging = ref<DragModel<GroupModel | QueueTasksModel>>();
provide('currentDragging', currentDragging);
/**Происходит ли перетаскивание */
const isDrag = ref(false);
provide('isDrag', isDrag);
/**Директория над которой перетаскивается элемент */
const currentDragOver = ref<NamespaceModel | GroupModel>();
provide('currentDragOver', currentDragOver);
/**Окно для отображения ошибки удаления элемента */
const $removeStopperModal = ref<InstanceType<typeof RemoveStopperModal>>();

/**rem единица */
const rem = computed(() => parseFloat(getComputedStyle(document.documentElement).fontSize));

/** Дефолтная ширина */
const minWidthToOpenSidebar = defaultSidebarWidth + 80;

/** Настроенная ширина */
const updatedOpenSidebarWidth = ref(defaultOpenSidebarWidth);

/** Вычисляемая ширина sidebar */
const sidebarWidth = computed(() => {
  if (props.isStatic) return props.width;
  /** Когда sidebar открыт */
  if (isSidebarOpen.value) {
    /** Когда обновленная ширина больше ширины по дефолту */
    if (updatedOpenSidebarWidth.value > defaultOpenSidebarWidth) {
      return updatedOpenSidebarWidth.value;
    } else {
      /** Когда изменяется размер sidebar */
      if (isResizing.value) {
        return updatedOpenSidebarWidth.value;
      } else {
        return updatedOpenSidebarWidth.value > minWidthToOpenSidebar
          ? updatedOpenSidebarWidth.value
          : minWidthToOpenSidebar;
      }
    }
  } else {
    return defaultSidebarWidth;
  }
});

/** Изменяется ли ширина sidebar */
const isResizing = ref(false);

/**
 * Начало изменение ширины sidebar
 * @param event
 */
const startResize = (event: MouseEvent) => {
  if (!isSidebarOpen.value) {
    isSidebarOpen.value = true;

    if (event.clientX < defaultSidebarWidth + 50) {
      showOnlyIcons.value = true;
    } else {
      showOnlyIcons.value = false;
    }
  }

  isResizing.value = true;

  setSidebarWidth(event.clientX);

  /** Отключаем выделение */
  document.body.style.userSelect = 'none';

  /** Отслеживание перемещение стрелки по экрану */
  document.addEventListener('mousemove', onResize);
  document.addEventListener('mouseup', onFinish);

  /** Отключает transition у sidebar чтобы не было задержек */
  // @ts-ignore
  document.querySelector('.sidebar').style.transition = '0s width';
  // @ts-ignore
  document.querySelector('.sidebar__open-btn').style.transition = '0s left';
};
/**Получить rem значение */
const getRem = (px: number) => {
  if (!px) return 0;
  return px / rem.value;
};

/**
 * Изменение ширины sidebar
 * @param event
 */
const onResize = (event: MouseEvent) => {
  if (!isResizing.value) return;

  if (event.clientX > minWidthToOpenSidebar) {
    showOnlyIcons.value = false;
    setSidebarWidth(event.clientX);
  } else if (event.clientX > defaultSidebarWidth && event.clientX < minWidthToOpenSidebar) {
    showOnlyIcons.value = true;
    setSidebarWidth(event.clientX);
  } else {
    setSidebarWidth(defaultSidebarWidth);
  }
};
/**Установка ширины сайдбара */
const setSidebarWidth = (width: number) => {
  updatedOpenSidebarWidth.value = width;
  document.dispatchEvent(
    new CustomEvent('sidebar-resize', { detail: updatedOpenSidebarWidth.value }),
  );
};

/**
 * Завершение изменение ширины sidebar
 * @param event
 */
const onFinish = (event: MouseEvent) => {
  if (!isResizing.value) return;

  isResizing.value = false;

  document.body.style.userSelect = 'auto';

  document.removeEventListener('mousemove', onResize);
  document.removeEventListener('mouseup', onFinish);

  // @ts-ignore
  document.querySelector('.sidebar').style.transition = '0.2s width';
  // @ts-ignore
  document.querySelector('.sidebar__open-btn').style.transition = '0.3s left';

  if (event.clientX < minWidthToOpenSidebar) {
    isSidebarOpen.value = false;
    showOnlyIcons.value = true;
    setSidebarWidth(defaultSidebarWidth);
  }
};

/** Переключатель видимости sidebar */
const toggleSidebar = (_isSidebarOpen: boolean) => {
  isSidebarOpen.value = _isSidebarOpen;
  showOnlyIcons.value = !_isSidebarOpen;
  setSidebarWidth(sidebarWidth.value);
};

/** Переключатель кнопки отображения sidebar */
const toggleSidebarBtnVisibility = (showBtn: boolean) => {
  const btn = document.querySelector('.sidebar__open-btn');

  if (!btn) return;
  if (showBtn) {
    btn.classList.add('sidebar__open-btn_visible');
  } else {
    btn.classList.remove('sidebar__open-btn_visible');
  }
};

const {
  sidebarItems,
  setSidebarItems,
  openMenuItemFromRoute,
  removeItem,
  addMenuItem,
  updateItem,
  move,
} = useSidebarTree();

const project = inject(projectInjectKey);

const openProject = () => {
  router.push({ name: 'project' });
};

/**При создании неймспейса */
const onCreateNamespace = (data: CreateNamespaceInfo) => {
  const projectData = project.value ?? props.projectProps;
  if (data.ProjectId && projectData.Id !== data.ProjectId) return;

  // Добавление неймспейса в сайдбар
  addMenuItem(
    new NamespaceModel({
      Id: data.Id,
      Name: data.Name,
      IconId: data.IconId,
      IconUrl: data.IconUrl,
      ColorId: data.ColorId,
      Color: data.Color,
    }),
    true,
  );
};

/**При удалении неймспейса */
const onDeleteNamespace = (data: DeleteNamespaceInfo) => {
  removeItem(data.NamespaceId, TreeItemType.Namespace);
};

/**При обновлении неймспейса */
const onUpdateNamespace = (data: UpdateNamespaceInfo) => {
  const namespace = new NamespaceModel({
    Id: data.Id,
    Name: data.Name,
    IconId: data.IconId,
    IconUrl: data.IconUrl,
    ColorId: data.ColorId,
    Color: data.Color,
  });
  updateItem(namespace);
};

/**При обновлении очереди */
const onUpdateQueue = (data: UpdateQueueNameModel) => {
  const queue = new QueueTasksModel({
    Id: data.QueueId,
    Name: data.Name,
  });
  updateItem(queue);
};

/**При создании очереди */
const onCreateQueue = (queue: QueueTasksModel) => {
  addMenuItem(queue);
};
/**При удалении очереди */
const onDeleteQueue = (queue: DeleteQueueInfoModel) => {
  removeItem(queue.QueueId, TreeItemType.Queue);
};
/**При удалении папки */
const onDeleteGroup = (_group: DeleteGroupEventResponseModel) => {
  removeItem(_group.GroupId, TreeItemType.Group);
};
/**При обновлении папки */
const onUpdateGroup = (data: GroupUpdateNameEventResponseModel) => {
  const group = new GroupModel({
    Id: data.GroupId,
    Name: data.Name,
  });
  updateItem(group);
};
/**При создании папки */
const createGroup = (_group: GroupCreateEventResponseModel) => {
  const group = new GroupModel({
    Id: _group.GroupId,
    Name: _group.Name,
    NamespaceId: _group.NamespaceId,
    Number: _group.Number,
  });
  addMenuItem(group);
};

/**Перемещение элемента в другую директорию */
const onMove = () => {
  const item = currentDragging.value?.Data;
  if (!item) return;

  const parentId = currentDragOver.value.Id;

  if (item.isGroup()) {
    adapter.moveGroup(item.Id, parentId);
  } else if (item.isQueue()) {
    adapter.moveQueue(item.Id, parentId);
  }

  move(item, parentId);

  isDrag.value = false;
  currentDragging.value = undefined;
  currentDragOver.value = undefined;
};
/**Открыть окно редактирования очереди */
const onEditQueue = (queueId: string) => {};
/**Открыть окно предупреждающее о невозможности удаления элемента */
const openRemoveStopperModal = (type: TreeItemType) => {
  $removeStopperModal.value?.open(type);
};
/**Изменить данные рабочей области */
const changeNamespace = (_namespace: NamespaceModel) => {
  const namespace = sidebarItems.value.find((x) => x.isNamespace() && x.Id == _namespace.Id);
  if (namespace) {
    namespace.Name = _namespace.Name;
  }
};
/**Получение кол-во пользователей команды текущего пользователя  */
const getMyTeamCountEmployees = async () => {
  const resp = await adapter.getMyTeamCountEmployees();

  if (resp.IsSuccess) {
    myTeamCountEmployees.value = resp.Value;
  }
};
/**Получение дерева проекта */
const setProjectTree = async () => {
  isLoading.value = true;
  const resp = await adapter.getTree(Number(project.value.Id), props.onlyNamespaces);
  isLoading.value = false;
  if (resp.IsSuccess) setSidebarItems(resp.Value);
  // emit("sidebarItems", sidebarItems);
};
/**Отправка события для открытия рабочей области */
const openNamespace = (namespaceId: string, route: RouteLocation) => {
  emit('openNamespace', namespaceId);
  if (props.isStatic) openMenuItemFromRoute(route);
};
/**Отправка события для открытия папки */
const openGroup = (namespaceId: string, groupId: number, route: RouteLocation) => {
  emit('openGroup', namespaceId, groupId);
  if (props.isStatic) openMenuItemFromRoute(route);
};
/**Отправка события для открытия очереди */
const openQueue = (namespaceId: string, queueId: string, route: RouteLocation) => {
  emit('openQueue', namespaceId, queueId);
  if (props.isStatic) openMenuItemFromRoute(route);
};

/**Подписаться/отписаться на/от события */
const toggleEvents = (isSubscribe: boolean) => {
  const eventFnName = isSubscribe ? 'on' : 'removeListener';

  adapter.CreateNamespaceEvent[eventFnName](onCreateNamespace);
  adapter.DeleteNamespaceEvent[eventFnName](onDeleteNamespace);
  adapter.UpdateNamespaceEvent[eventFnName](onUpdateNamespace);
  adapter.UpdateQueueEvent[eventFnName](onUpdateQueue);
  adapter.DeleteQueueEvent[eventFnName](onDeleteQueue);
  adapter.CreateQueueEvent[eventFnName](onCreateQueue);
  adapter.OnCreateGroupEvent[eventFnName](createGroup);
  adapter.OnDeleteGroupEvent[eventFnName](onDeleteGroup);
  adapter.OnUpdateNameGroupEvent[eventFnName](onUpdateGroup);
};

const getData = async () => {
  try {
    if (!props.isStatic) {
      getMyTeamCountEmployees();
    }
    await setProjectTree();
    if (!props.isStatic) {
      openMenuItemFromRoute(router.currentRoute.value);
    }
  } catch (e) {
    console.error(e);
  }
};

/**Отслеживание изменения id проекта */
watch(
  () => project?.value?.Id,
  () => {
    getData();
  },
);

onMounted(async () => {
  try {
    if (!props.skipInit) {
      await getData();
    }
    toggleEvents(true);
  } catch (e) {
    console.error(e);
  }
  setTimeout(() => setSidebarWidth(defaultOpenSidebarWidth));
});

watch(
  () => router.currentRoute.value.path,
  () => {
    setTimeout(() => setSidebarWidth(defaultOpenSidebarWidth));
  },
);

onUnmounted(() => {
  toggleEvents(false);
});

const isProjectAdmin = computed(() => {
  const x = CurrentUser;
  const rez = project.value.Admins.find((el) => el.Id == x.Id);
  return rez ? true : false;
});
const isOwner = computed(() => {
  const x = CurrentUser;
  const rez = x?.Roles.includes(2);
  return rez ? true : false;
});
/**Админ хоть в 1 неймспейсе */
const isNamespaceAdmin = computed(() =>
  sidebarItems.value.some((item) => item.isNamespace() && item.IsAdminNamespace),
);

onBeforeRouteUpdate((to) => {
  if (project.value.Id === Number(to.params?.projectId)) {
    openMenuItemFromRoute(to);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: _normalizeClass(["sidebar-wrapper", { static: __props.isStatic }]),
        onMouseover: _cache[3] || (_cache[3] = ($event: any) => (toggleSidebarBtnVisibility(true))),
        onMouseout: _cache[4] || (_cache[4] = ($event: any) => (toggleSidebarBtnVisibility(false)))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["sidebar", { sidebar_open: isSidebarOpen.value, static: __props.isStatic }]),
          style: _normalizeStyle({
          width: getRem(sidebarWidth.value) + 'rem',
        })
        }, [
          (isLoading.value)
            ? (_openBlock(), _createBlock(_unref(SidebarSkeleton), { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                  class: _normalizeClass(["sidebar__open-btn", { 'sidebar__open-btn_open-sidebar': isSidebarOpen.value }]),
                  style: _normalizeStyle({ left: getRem(sidebarWidth.value - 24) + 1.25 + 'rem' }),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSidebar(!isSidebarOpen.value)))
                }, [
                  _createVNode(_unref(TirPmButton), {
                    class: "sidebar__button-arrow",
                    variant: _unref(TirPmButtonVariantEnum).LinkState,
                    size: _unref(TirPmButtonSizeEnum).Small
                  }, {
                    leftSlot: _withCtx(() => [
                      _createVNode(_unref(ArrowRightIcon), { style: {"width":"1rem","height":"1rem"} })
                    ]),
                    _: 1
                  }, 8, ["variant", "size"])
                ], 6),
                (!__props.hideProjectInfo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["sidebar__project-title", { 'menu__wrapper_open-sidebar': isSidebarOpen.value }]),
                        onClick: openProject
                      }, [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_unref(TirPmIconView), {
                            size: 48,
                            isRounded: "",
                            isBordered: false,
                            imageLoadUrl: _unref(project).ImageUrl,
                            colorCode: _unref(project).PreviewColor
                          }, {
                            mainSlot: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(project)?.Name[0].toUpperCase()), 1)
                            ]),
                            _: 1
                          }, 8, ["imageLoadUrl", "colorCode"])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["menu__title_hidden", {
                  menu__title_visible: (isSidebarOpen.value && !showOnlyIcons.value) || !_unref(project).ImageUrl,
                }])
                        }, _toDisplayString(_unref(project).Name), 3)
                      ], 2),
                      _hoisted_4
                    ]))
                  : _createCommentVNode("", true),
                (!__props.isStatic)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["menu__items", { 'menu__items--close': !isSidebarOpen.value }])
                    }, [
                      (isProjectAdmin.value || isOwner.value)
                        ? (_openBlock(), _createBlock(_unref(MonitoringMenu), {
                            key: 0,
                            isSidebarOpen: isSidebarOpen.value,
                            showOnlyIcons: showOnlyIcons.value
                          }, null, 8, ["isSidebarOpen", "showOnlyIcons"]))
                        : _createCommentVNode("", true),
                      (isProjectAdmin.value || isOwner.value)
                        ? (_openBlock(), _createBlock(_unref(CreateNamespaceDrawer), {
                            key: 1,
                            "project-id": _unref(project).Id
                          }, {
                            default: _withCtx(({ open }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["sidebar__menu-add menu__wrapper menu__item", { 'menu__wrapper_open-sidebar': isSidebarOpen.value }]),
                                onClick: open
                              }, [
                                _createVNode(_unref(PlusIcon), {
                                  class: _normalizeClass(["menu__icon", { 'menu__icon_open-sidebar': isSidebarOpen.value }])
                                }, null, 8, ["class"]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["menu__title_hidden", { menu__title_visible: isSidebarOpen.value && !showOnlyIcons.value }])
                                }, " Рабочая область ", 2)
                              ], 10, _hoisted_5)
                            ]),
                            _: 1
                          }, 8, ["project-id"]))
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true),
                _createVNode(_unref(TirPmScrollbar), {
                  class: "sidebar-menu-scroll",
                  "show-on-hover": true
                }, {
                  default: _withCtx(() => [
                    (_unref(sidebarItems)?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sidebarItems), (item, idx) => {
                            return (_openBlock(), _createBlock(_unref(SidebarMenuItem), {
                              key: idx,
                              "menu-item": item,
                              "is-sidebar-open": isSidebarOpen.value || __props.isStatic,
                              level: 0,
                              sidebarWidth: sidebarWidth.value,
                              showOnlyIcons: showOnlyIcons.value && !__props.isStatic,
                              isStatic: __props.isStatic,
                              "have-action-item": haveActionItem.value,
                              onOnMove: onMove,
                              onUnableDeleteQueue: openRemoveStopperModal,
                              onUnableDeleteGroup: openRemoveStopperModal,
                              onUnableDeleteNamespace: openRemoveStopperModal,
                              onOpenNamespace: openNamespace,
                              onOpenGroup: openGroup,
                              onOpenQueue: openQueue,
                              "onUpdate:haveActionItem": _cache[1] || (_cache[1] = ($event: any) => (haveActionItem.value = $event))
                            }, null, 8, ["menu-item", "is-sidebar-open", "sidebarWidth", "showOnlyIcons", "isStatic", "have-action-item"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]))
        ], 6),
        (!__props.isStatic)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "sidebar__line-wrapper",
              onMousedown: _cache[2] || (_cache[2] = ($event: any) => (startResize($event)))
            }, _hoisted_8, 32))
          : _createCommentVNode("", true)
      ], 34),
      _createElementVNode("div", {
        class: "sidebar-block-width",
        style: _normalizeStyle({
        width: getRem(sidebarWidth.value) + 'rem',
      })
      }, null, 4)
    ]),
    _createVNode(RemoveStopperModal, {
      ref_key: "$removeStopperModal",
      ref: $removeStopperModal
    }, null, 512)
  ], 64))
}
}

})